import { footerLinks } from "@/mocks/chiagua";

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-news-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                吃瓜福利<span className="text-primary-500">会员站</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注聚合内部资源与付费内容的会员平台，独家爆料、深度整理一站解锁，陪你轻松跟上每一场热度。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a href="#join" aria-label="微信" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#join" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#join" aria-label="知乎" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600">
                <i className="ri-zhihu-line"></i>
              </a>
              <a href="#join" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-900">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 吃瓜福利会员站 · 本站内容仅作展示，部分瓜料来自网友整理。</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600">会员开通指南</a>
            <a href="#top" className="hover:text-primary-600">免责声明</a>
            <a href="#top" className="hover:text-primary-600">内容举报</a>
          </p>
        </div>
      </div>
    </footer>
  );
}